import { useLoadingBar } from '../../lib/use-loading';

/**
 * Top progress bar. While any API request is in flight the bar grows in width
 * from the left (loading phase); when the last request settles it fills to
 * 100% and fades out (completing phase). Replaces per-screen skeleton flicker
 * — content stays mounted, this bar is the only loading affordance.
 */
export function LoadingBar() {
  const phase = useLoadingBar();

  if (phase === 'idle') return null;

  return (
    <div
      aria-busy={phase === 'loading'}
      aria-live="polite"
      className="loadingbar-track pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px] bg-accent/10"
    >
      <div
        className={
          phase === 'loading'
            ? 'loadingbar-grow absolute inset-y-0 left-0 bg-accent'
            : 'loadingbar-fade absolute inset-y-0 left-0 w-full bg-accent'
        }
      />
    </div>
  );
}
